import React, { useState } from 'react';
import { inferFieldComponent } from '../../utils/inferInputFieldComponent';
import { useAjvValidator } from '../../hooks/useAvjValidator';

import { NumberInput } from './NumberInput';
import { DateInput } from './DateInput';
import { DatetimeInput } from './DatetimeInput';
import { TimeInput } from './TimeInput';
import { EmailInput } from './EmailInput';
import { UrlInput } from './UrlInput';
import { SelectInput } from './SelectInput';
import { TextareaInput } from './TextareaInput';
import { StringInput } from './StringInput';

export default function FieldInput({
  column,
  value,
  onSave,
  onCancel,
  className
}) {
  const [draft, setDraft] = useState(value);
  const componentType = inferFieldComponent(column);
  const validate = useAjvValidator(column);
  const [error, setError] = useState(null);

  const handleSave = (val) => {
    const isEqual = typeof value === 'object' && value !== null 
      ? JSON.stringify(value) === JSON.stringify(val)
      : String(value ?? "") === String(val ?? "");

    if (isEqual) {
      if (onCancel) onCancel();
      return true;
    }

    const err = validate(val);
    if (err) {
      setError(err);
      return false;
    }
    setError(null);
    onSave(val);

    if (onCancel) {
      onCancel()
    }

    return true;
  };

  const sharedProps = {
    value: draft,
    onChange: setDraft,
    onSave: handleSave,
    onCancel,
    error,
    schema: column,
    autoFocus: true,
    className
  };

  const COMPONENT_MAP = {
    number: NumberInput,
    date: DateInput,
    datetime: DatetimeInput,
    time: TimeInput,
    email: EmailInput,
    url: UrlInput,
    select: SelectInput,
    textarea: TextareaInput,
    string: StringInput,
    'json-dialog': StringInput, // Fallback
  };

  const InputComponent = COMPONENT_MAP[componentType] || StringInput;
  console.log(componentType)


  return <InputComponent {...sharedProps} />;
}